module.exports = __webpack_public_path__ + "img/tpc-web-9.d675dab0.jpg";